import { useFlow } from "../../../FlowEdit/useFlow";
import { InputNumber } from "antd";
import { RenderInputProps } from "../types";

export default function NumerInput({ item, moduleId }: RenderInputProps) {
  const { updateNodeValue } = useFlow();

  return (
    <InputNumber
      defaultValue={item.value as number}
      onBlur={(e) => {
        updateNodeValue(moduleId, item.key, e.target.value);
      }}
      max={item.max}
      min={item.min}
      style={{ width: "100%" }}
    />
  );
}
